<footer class="footer">
  <div class="container-fluid">
    <!-- <nav class="pull-left">
      <ul class="nav">
        <li class="nav-item">
          <a class="nav-link" href="https://www.themekita.com">
            ThemeKita
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">
            Help
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">
            Licenses
          </a>
        </li>
      </ul>
    </nav> -->
    <div class="copyright ml-auto">
      <!-- 2019, made with <i class="fa fa-heart heart text-danger"></i> by <a href="https://www.themekita.com">ThemeKita</a> -->
      2019, &copy; Copyrights reserved
    </div>
  </div>			
</footer>